module.exports = __webpack_public_path__ + "img/category_15.698e6c4f.png";